import { gql } from '@apollo/client';

export const CLICKABLE_COUNTRY_QUERY = gql`
  query mapInteractiveCountries($filters: JSON, $selectedCountry: JSON) {
    mapInteractiveCountries(filters: $filters, selectedCountry: $selectedCountry) {
      feature
    }
  }
`;

export const GET_MAP_CONFIG_QUERY = gql`
  query mapboxConfig {
    mapboxConfig {
      mapboxSourceUrl
    }
  }
`;
